/**
 * Import from node_modules
 */
// import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import Menu from './site/menu';
import ScrollTo from './site/scrollTo';
import Header from './site/header';
import SearchModal from './site/search-modal';
import scrollAnimate from './shared/scroll-animate';
import YouTubePlayers from './shared/youtube-players';

/**
 * Init site scripts
 */
jQuery(function() {
	Menu.init();
	ScrollTo.init();
	Header.init();
	SearchModal.init();
	scrollAnimate.init();
	YouTubePlayers.init();
});
